import defaultStyle from './styles/DateRenderer.scss';

const DateRenderer = ({ date, style = defaultStyle }) => (
	<div className={style.date}>
		<span>{date.getFullYear()}</span>
		<div className={style.divider} />
		<span>{(date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))}</span>
		<div className={style.divider} />
		<span>{(date.getDate() < 10 ? '0' + date.getDate() : date.getDate())}</span>
	</div>
);

export default DateRenderer;


// WEBPACK FOOTER //
// ./components/blocks/raffleDetail/DateRenderer.js